import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import {
	BankAccountFormatRuleRes,
	BankAccountSupportedCountryRes,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const getBankAccountSupportedCountries = async () => {
	const response = await makeRequest<ApiV1.Response<BankAccountSupportedCountryRes[]>>({
		endpoint: API_PATHS.BANK_ACCOUNT_SUPPORTED_COUNTRIES_GET,
		method: HTTP_METHOD.GET,
	});

	return response.payload;
};

export const getBankAccountFormatRules = async (countryCode: string) => {
	const response = await makeRequest<ApiV1.Response<BankAccountFormatRuleRes[]>>({
		endpoint: formatUnicorn(API_PATHS.BANK_ACCOUNT_FORMAT_RULES_COUNTRYCODE_GET, {
			countryCode,
		}),
		method: HTTP_METHOD.GET,
	});

	return response.payload;
};
